import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  requireModuleSelection: true, // Show module suggestions (Recipe Summarizer/Q&A/Creator/Drafter) on the welcome screen
};

const moduleSelectionSlice = createSlice({
  name: "moduleSelection",
  initialState,
  reducers: {
    setRequireModuleSelection: (state, action) => {
      state.requireModuleSelection = action.payload;
    },
    toggleModuleSelection: (state) => {
      state.requireModuleSelection = !state.requireModuleSelection;
    },
  },
});

export const { setRequireModuleSelection, toggleModuleSelection } =
  moduleSelectionSlice.actions;
export default moduleSelectionSlice.reducer;
